import i18n from "i18next";
import { initReactI18next } from "react-i18next";

let vi = {};
let en = {};

const resource: { [key: string]: any } = {
  vi: { translation: vi },
  en: { translation: en },
};

// Get all language folders in locales directory
// @ts-ignore
const folderContext = require.context("../locales", true, /all\.json$/);
folderContext.keys().forEach((key: string) => {
  const lang = key.split("/")[1];
  const dataText = folderContext(key);
  resource[lang] = { translation: dataText };
});

const lang = localStorage.getItem("lang") || "vi";
i18n.use(initReactI18next).init({
  fallbackLng: {
    vi: ["en"],
    en: ["vi"],
    ko: ["en", "zh-Hant", "vi"],
    ja: ["en", "zh-Hant", "vi"],
    "zh-Hant": ["zh-Hans", "en", "vi"],
    "zh-Hans": ["zh-Hant", "en", "vi"],
    "zh-CN": ["zh-Hans", "zh-Hant", "en", "vi"],
    default: ["en", "vi"],
    "my-MM": ["my"],
    "es-ES": ["es"],
    "de-DE": ["de"],
    "cs-CZ": ["cs"],
    "fr-FR": ["fr"],
    "bn-BD": ["bn-BD"],
    zh: ["zh-Hant"],
    bn: ["bn-BD"],
    pt: ["pt-PT"],
  },
  debug: false,
  resources: resource,
  lng: lang,
  ns: ["translation"],
  keySeparator: ".",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  defaultNS: "translation",
});

export default i18n;
